export class DeactivateAccountRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "domain",
            "baseName": "domain",
            "type": "string",
            "format": ""
        },
        {
            "name": "force",
            "baseName": "force",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DeactivateAccountRequest.attributeTypeMap;
    }
    constructor() {
    }
}
